import React from "react";
import { Link } from "react-router-dom";

const SIZE_MAP = {
  sm: "h-10",
  md: "h-14",
  lg: "h-20",
  xl: "h-16 sm:h-24 lg:h-28",
  footer: "h-20 sm:h-24",
};

const LOGO_SRC = {
  navy: "/media/cm-lindley-logo-navy.png",
  white: "/media/cm-lindley-logo-white.png",
};

/**
 * Renders the CM Lindley wordmark from the client-approved PNG assets.
 * variant="navy"  → navy wordmark for light backgrounds (header)
 * variant="white" → white wordmark for dark backgrounds (footer)
 */
export const Logo = ({ variant = "navy", size = "xl", asLink = true, className = "" }) => {
  const h = SIZE_MAP[size] || SIZE_MAP.md;
  const src = LOGO_SRC[variant] || LOGO_SRC.navy;

  const mark = (
    <span
      data-testid="logo-mark"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={src}
        alt="CM Lindley"
        className={`${h} w-auto`}
        draggable={false}
      />
    </span>
  );

  if (!asLink) return mark;

  return (
    <Link
      to="/"
      data-testid="logo-link"
      aria-label="CM Lindley home"
      className="inline-flex items-center"
    >
      {mark}
    </Link>
  );
};

export default Logo;
